import PressCacheDescription from "../../../../src/courses/partials/services/presscache.mdx";
import * as React from 'react';
export default {
  PressCacheDescription,
  React
};